module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAhUExURU1vqU1uqU9tqk1vqf////r7/bLA2qCy0VN0rIGZwt3k76kQlwMAAAADdFJOU/2yKkoiIbEAAAB3SURBVDjLzdNBDsAgCATApYpK///gKl6sVUzag90TCRODJOAguGlAB8iZIcAGq34Wr4BEzQwI+5o0BsF7E4i3QeIFaB4Yg6gtSSXDX+iIbOzhGwg5p85QqiAP0PywJG4BObVXKo47FvVfABugP94eELrzv4N8/hcH+g2Yq2d/MQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/facebook.png
// module id = +ces
// module chunks = 1